import { render, staticRenderFns } from "./WapTopIntrAz.vue?vue&type=template&id=5fc80207&scoped=true&"
import script from "./WapTopIntrAz.vue?vue&type=script&lang=js&"
export * from "./WapTopIntrAz.vue?vue&type=script&lang=js&"
import style0 from "./WapTopIntrAz.vue?vue&type=style&index=0&id=5fc80207&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc80207",
  null
  
)

export default component.exports